<template>
    <div>
        <h2>Features</h2>
        <div v-if="loading">
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        </div>
        <div v-if="!loading">
            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td class="pl-0">Bedrooms</td>
                            <td class="text-right">{{ bedroomsFormatted }}</td>
                        </tr>
                        <tr>
                            <td class="pl-0">Bathrooms</td>
                            <td class="text-right">{{ listing.bathroomsFormatted }}</td>
                        </tr>
                        <tr>
                            <td class="pl-0">Reception rooms</td>
                            <td class="text-right">{{ listing.receptionRoomsFormatted }}</td>
                        </tr>
                        <tr>
                            <td class="pl-0">Number of floors</td>
                            <td class="text-right">{{ listing.propertyDetails.numberOfFloors }}</td>
                        </tr>
                        <tr>
                            <td class="pl-0">Entrance floor</td>
                            <td class="text-right">{{ listing.propertyDetails.floor.name }}</td>
                        </tr>
                        <tr>
                            <td class="pl-0">Tenure</td>
                            <td class="text-right text-capitalize">{{ listing.tenure }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from '@vue/composition-api';
import {has} from "lodash";

export default defineComponent({
    name: "SinglePropertyFeatures",
    props: {
        listing: {
            type:  Object,
            required: true
        },
    },
    setup(props, context) {
        const loading = ref(true);
        const bedroomsFormatted = computed(() => {
            if(has(props, 'listing.bedroomsFormatted')) {
                if(props.listing.bedroomsFormatted === '0' || props.listing.bedroomsFormatted === 0) {
                    return 'Studio';
                }
                return props.listing.bedroomsFormatted;
            }
            return '';
        });

        onMounted(() => {
            init();
        });

        function init() {
            loading.value = false;
        }

        return {
            // Variables
            loading,
            bedroomsFormatted
            // Functions
        }

    }
});
</script>
